import { render, staticRenderFns } from "./Cita.vue?vue&type=template&id=9823a588&scoped=true&"
import script from "./Cita.vue?vue&type=script&lang=js&"
export * from "./Cita.vue?vue&type=script&lang=js&"
import style0 from "./Cita.vue?vue&type=style&index=0&id=9823a588&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9823a588",
  null
  
)

export default component.exports